import React from 'react';
import { render } from 'react-dom';
import Router from './module/Router';

document.addEventListener('DOMContentLoaded', function (): void {
  render(<Router/>, document.querySelector('#main'));
});